export const GIS_SERVICE_CATEGORIES = [
  {
    id: 'arcgis-national',
    name: 'الخدمات الوطنية',
    icon: '🗺️',
    color: '#1E88E5',
    description: 'طبقات وطنية ومحورية مخزنة على خوادم خرائط موثوقة.'
  },
  {
    id: 'geoserver',
    name: 'الخدمات المفتوحة',
    icon: '🌐',
    color: '#66BB6A',
    description: 'خدمات مفتوحة لعرض الخرائط وبيانات المعالم على نطاق مصر وأفريقيا.'
  },
  {
    id: 'arcgis-cairo',
    name: 'خدمات القاهرة',
    icon: '🏙️',
    color: '#D4AF37',
    description: 'خدمات محلية تابعة لبوابة القاهرة الجغرافية.'
  }
];

const egyptCenter = { lat: 26.8206, lng: 30.8025 };

export const GIS_SERVICES = [
  {
    id: 'egypt_resource_map',
    name: 'خريطة موارد مصر الوطنية',
    description: 'خريطة موارد وطرق وأماكن مأهولة وحدود مصر في خدمة معالم وطنية.',
    type: 'FeatureServer',
    category: 'arcgis-national',
    lat: egyptCenter.lat,
    lng: egyptCenter.lng,
    url: 'https://services1.arcgis.com/0MSEUqKaxRlEPj5g/ArcGIS/rest/services/Eygpt_Resource_Map_WFL1/FeatureServer'
  },
  {
    id: 'idsc_egis_root',
    name: 'خادم الخدمات المكانية الوطني',
    description: 'مدخل رئيسي لخدمات مكانية مستضافة تخص مصر.',
    type: 'Root',
    category: 'arcgis-national',
    lat: egyptCenter.lat,
    lng: egyptCenter.lng,
    url: 'https://www.egis.idsc.gov.eg/server/rest/services/Hosted'
  },
  {
    id: 'egcapitalgis_root',
    name: 'بوابة العاصمة المكانية',
    description: 'خادم يقدم خدمات مكانية متنوعة تخص قطاعات مصر المختلفة.',
    type: 'Root',
    category: 'arcgis-national',
    lat: egyptCenter.lat,
    lng: egyptCenter.lng,
    url: 'https://egcapitalgis.idsc.gov.eg/server/rest/services/'
  },
  {
    id: 'egcapitalgis_hosted',
    name: 'خدمة البيانات القطاعية لمصر',
    description: 'خدمة مستضافة لبيانات قطاعية على مستوى الدولة.',
    type: 'FeatureServer',
    category: 'arcgis-national',
    lat: egyptCenter.lat,
    lng: egyptCenter.lng,
    url: 'https://egcapitalgis.idsc.gov.eg/server/rest/services/Hosted/egypt_user/FeatureServer'
  },
  {
    id: 'hydro_egypt',
    name: 'الشبكة المائية في مصر',
    description: 'طبقات هيدرولوجية تغطي الشبكة المائية في مصر.',
    type: 'FeatureServer',
    category: 'arcgis-national',
    lat: 30.0444,
    lng: 31.2357,
    url: 'https://pro-ags2.dfs.un.org/arcgis/rest/services/hosted/Hydro_Egypt/FeatureServer'
  },
  {
    id: 'egypt_water_bodies',
    name: 'المسطحات المائية في مصر',
    description: 'مسطحات مائية تشمل النيل والبحيرات والسواحل.',
    type: 'FeatureServer',
    category: 'arcgis-national',
    lat: 30.0444,
    lng: 31.2357,
    url: 'https://gis.wfp.org/arcgis/rest/services/Hosted/Egypt_Water_Bodies/FeatureServer'
  },
  {
    id: 'egypt_scrub_forest',
    name: 'الغطاء النباتي والغابات في مصر',
    description: 'غطاء نباتي يوضح مناطق الشجيرات والغابات.',
    type: 'FeatureServer',
    category: 'arcgis-national',
    lat: 30.0444,
    lng: 31.2357,
    url: 'https://services5.arcgis.com/SaBe5HMtmnbqSWlu/ArcGIS/rest/services/Egypt_Scrub_and_Forest/FeatureServer'
  },
  {
    id: 'egypt_province_boundaries',
    name: 'حدود المحافظات المصرية ٢٠٢٣',
    description: 'حدود المحافظات المصرية لإصدار عام ٢٠٢٣.',
    type: 'Web Map',
    category: 'arcgis-national',
    lat: 31.2058,
    lng: 29.9245,
    url: 'https://wb-sdgs.hub.arcgis.com/maps/df8f91346ed3405692df906185b76ce8'
  },
  {
    id: 'egypt_boundaries_online',
    name: 'حدود مصر متعددة المستويات',
    description: 'عنصر خرائط يعرض حدود مصر بعدة مستويات إدارية.',
    type: 'ArcGIS Item',
    category: 'arcgis-national',
    lat: 30.0444,
    lng: 31.2357,
    url: 'https://www.arcgis.com/home/item.html?id=3188f9d1c3fc4f19b5f8181f24c8d368'
  },
  {
    id: 'fao_geoserver_base',
    name: 'خدمة الخرائط الأساسية من منظمة الأغذية والزراعة',
    description: 'خدمة خرائط أساسية مقدمة من منظمة الأغذية والزراعة.',
    type: 'WMS',
    category: 'geoserver',
    lat: 30.0444,
    lng: 31.2357,
    url: 'http://data.fao.org/maps/ows'
  },
  {
    id: 'fao_geoserver_wms',
    name: 'وصف إمكانات خدمة الخرائط المفتوحة',
    description: 'رابط يوضح إمكانات خدمة الخرائط المفتوحة من المنظمة.',
    type: 'WMS Capabilities',
    category: 'geoserver',
    lat: 30.0444,
    lng: 31.2357,
    url: 'http://data.fao.org/maps/ows?SERVICE=WMS&REQUEST=GetCapabilities'
  },
  {
    id: 'isric_farming_wms',
    name: 'أنظمة الزراعة في أفريقيا - عرض خرائط',
    description: 'خدمة لعرض نظم الزراعة في أفريقيا مع إمكانية التركيز على مصر.',
    type: 'WMS Capabilities',
    category: 'geoserver',
    lat: 30.0444,
    lng: 31.2357,
    url: 'https://africasis.isric.org/ows/farming-systems?service=WMS&request=GetCapabilities'
  },
  {
    id: 'isric_farming_wfs',
    name: 'أنظمة الزراعة في أفريقيا - بيانات معالم',
    description: 'خدمة بيانات معالم لنظم الزراعة في أفريقيا.',
    type: 'WFS Capabilities',
    category: 'geoserver',
    lat: 30.0444,
    lng: 31.2357,
    url: 'https://africasis.isric.org/ows/farming-systems?service=WFS&request=GetCapabilities'
  },
  {
    id: 'geoportal_cairo_root',
    name: 'بوابة القاهرة الجغرافية',
    description: 'المدخل الرئيسي لخدمات بوابة القاهرة الجغرافية.',
    type: 'Root',
    category: 'arcgis-cairo',
    lat: 30.0444,
    lng: 31.2357,
    url: 'https://geoportal.cairodc.gov.eg/server/rest/services'
  },
  {
    id: 'cairo_boundaries',
    name: 'محافظة القاهرة بالحدود',
    description: 'خدمة خرائط لحدود محافظة القاهرة.',
    type: 'MapServer',
    category: 'arcgis-cairo',
    lat: 30.0455,
    lng: 31.2359,
    url: 'https://geoportal.cairodc.gov.eg/server/rest/services/محافظة_القاهرة_بالحدود/MapServer'
  },
  {
    id: 'gamaliya_services',
    name: 'خدمات حي الجمالية',
    description: 'خدمة خرائط لبيانات البنوك والمدارس والمستشفيات بحي الجمالية.',
    type: 'MapServer',
    category: 'arcgis-cairo',
    lat: 30.0874,
    lng: 31.2617,
    url: 'https://geoportal.cairodc.gov.eg/server/rest/services/خدمات_الجمالية/MapServer'
  },
  {
    id: 'maadi_services',
    name: 'خدمات حي المعادي',
    description: 'خدمة خرائط توضح النوادي والخدمات الأخرى في حي المعادي.',
    type: 'MapServer',
    category: 'arcgis-cairo',
    lat: 29.9636,
    lng: 31.2751,
    url: 'https://geoportal.cairodc.gov.eg/server/rest/services/خدمات_حى_المعادى/MapServer'
  }
];

export const SERVICE_TYPE_LABELS = {
  FeatureServer: 'خدمة معالم',
  Portal: 'بوابة خرائط',
  Root: 'مدخل خدمات',
  'Web Map': 'خريطة ويب',
  'ArcGIS Item': 'عنصر خرائط',
  MapServer: 'خدمة خرائط',
  WMS: 'عرض خرائط',
  'WMS Capabilities': 'إمكانات عرض الخرائط',
  'WFS Capabilities': 'إمكانات بيانات المعالم'
};

export const getServiceColor = (categoryId) => {
  const category = GIS_SERVICE_CATEGORIES.find((item) => item.id === categoryId);
  return category?.color || '#7F8C8D';
};

export const getServiceIcon = (type) => {
  const icons = {
    FeatureServer: '🛰️',
    Portal: '🌍',
    Root: '🧭',
    'Web Map': '🗺️',
    'ArcGIS Item': '📦',
    MapServer: '🏙️',
    WMS: '🛰️',
    'WMS Capabilities': '📡',
    'WFS Capabilities': '🛰️'
  };
  return icons[type] || '🗂️';
};

export const getServiceTypeLabel = (type) => SERVICE_TYPE_LABELS[type] || 'نوع خدمة';

export const getServiceCategoryLabel = (categoryId) => (
  GIS_SERVICE_CATEGORIES.find((item) => item.id === categoryId)?.name || ''
);
